import React, { useState, useEffect } from 'react';
import { useUser } from '../context/UserContext';
import { getWeeklyActivity } from '../services/activityService';
import './WeeklyProgress.css';

const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Returns the Monday of the week containing `date`
function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

function formatLabel(dateStr) {
  const [, month, day] = dateStr.split('-');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
}

const WeeklyProgress = () => {
  const { currentUser } = useUser();
  const [weekStart, setWeekStart] = useState(getMonday(new Date()));
  const [weekData, setWeekData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;
    setIsLoading(true);
    getWeeklyActivity(currentUser.id, weekStart).then(({ data }) => {
      setWeekData(data || []);
      setIsLoading(false);
    });
  }, [currentUser, weekStart]);

  const goToPreviousWeek = () => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() - 7);
    setWeekStart(d);
  };

  const goToNextWeek = () => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + 7);
    setWeekStart(d);
  };

  return (
    <div className="weekly-progress">
      <h2>Weekly Progress</h2>

      <div className="week-navigation">
        <button onClick={goToPreviousWeek}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <div className="week-display">
          Week of {weekStart.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
        </div>
        <button onClick={goToNextWeek}>
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>

      {isLoading ? (
        <p style={{ textAlign: 'center', padding: '2rem' }}>Loading...</p>
      ) : (
        <div className="week-calendar">
          {weekData.map((day, index) => (
            <div
              key={day.date}
              className={`day-card ${day.hasActivity ? 'completed' : ''} ${day.perfect ? 'perfect' : ''}`}
            >
              <div className="day-header">
                <span className="day-name">{DAY_LABELS[index]}</span>
                <span className="day-date">{formatLabel(day.date)}</span>
              </div>
              <div className="day-status">
                {day.hasActivity ? (
                  <i className={`fas fa-check-circle ${day.perfect ? 'perfect' : 'completed'}`}></i>
                ) : (
                  <i className="fas fa-clock"></i>
                )}
              </div>
              {day.perfect && <div className="perfect-badge">Perfect Day!</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WeeklyProgress;
